import EditVendorProductContainer from "./EditVendorProductContainer";
export default EditVendorProductContainer;
